import * as actions from "../Actions/type";

const initSate = {

    user: (localStorage.easycardUser) ? JSON.parse(localStorage.easycardUser) : null,
};

const AuthReducer = (state = initSate, action) => {

    switch (action.type) {

        case actions.LOGIN:
            {

                let user = { ...action.payload.user
                };

                user.auth = { ...action.payload.auth,
                    accessToken: action.payload.access_token
                };

                localStorage.easycardUser = JSON.stringify(user);
                return { ...state,
                    user
                };
            }

        case actions.EDIT_USER_PROFILE:
            {
                let user = action.payload;

                if(user.id === state.user.id){
                    const fuser = { ...state.user,
                        ...user
                    }
                    localStorage.easycardUser = null;
                    localStorage.easycardUser = JSON.stringify(fuser);
                    return {
                        ...state,
                        user: fuser
                    };
                }
                return state;
            }

        case actions.LOGOUT:
            {
                localStorage.easycardUser = null;
                return { ...state,
                    user: null
                };
            }

        default:
            {
                return state;
            }
    }

};

export default AuthReducer;